import React, { useMemo } from 'react';
import './index.scss';
import { apiHolder as api, apis } from 'api';
import { useContactEmailRole } from '@web-common/hooks/useContactModel';
import { getIn18Text } from 'api';
import { Tooltip } from 'antd';
import { useGetProductAuth } from '@web-common/hooks/useGetProductAuth';
const contactApi = api.api.requireLogicalApi(apis.contactApiImpl);
const systemApi = api.api.getSystemApi();
const accountApi = api.api.requireLogicalApi(apis.accountApiImpl);
export const CustomerLabelByRole = props => {
    const { role: emailRole, simpleStyle, style, isContact, showEnterpriseLabel = false, isShort } = props;
    let labelText = '';
    let labelClass = '';
    const { productVersionInfo: { navigateVersion }, } = useGetProductAuth();
    const emailRoleList = useMemo(() => {
        if (process.env.BUILD_ISEDM) {
            return [
                'myCustomer',
                'colleagueCustomer',
                'colleagueCustomerNoAuth',
                'enterprise',
                'openSeaCustomer',
                'myClue',
                'colleagueClue',
                'colleagueClueNoAuth',
                'openSeaClue',
            ];
        }
        else if (navigateVersion) {
            return ['myCustomer', 'colleagueCustomer', 'colleagueCustomerNoAuth', 'enterprise'];
        }
        else if (process.env.BUILD_ISLINGXI) {
            return ['enterprise'];
        }
        return ['enterprise'];
    }, [navigateVersion]);
    if (!emailRoleList.includes(emailRole)) {
        return React.createElement(React.Fragment, null);
    }
    const textObj = {
        myCustomer: getIn18Text('WODEKEHU'),
        colleagueCustomer: getIn18Text('colleagueCustomer'),
        colleagueCustomerNoAuth: getIn18Text('colleagueCustomer'),
        openSeaCustomer: getIn18Text('GONGHAIKEHU'),
        enterprise: getIn18Text('colleague'),
        myClue: getIn18Text('WODEXIANSUO'),
        colleagueClue: getIn18Text('TONGSHIXIANSUO'),
        colleagueClueNoAuth: getIn18Text('TONGSHIXIANSUO'),
        openSeaClue: getIn18Text('GONGHAIXIANSUO'),
    };
    const classNameObj = {
        myCustomer: 'my-customer-label',
        colleagueCustomer: 'colleague-customer-label',
        colleagueCustomerNoAuth: 'colleague-customer-label',
        openSeaCustomer: 'openSea-customer-label',
        enterprise: 'enterprise-label',
        myClue: 'my-clue-label',
        colleagueClue: 'colleague-clue-label',
        colleagueClueNoAuth: 'colleague-clue-label',
        openSeaClue: 'openSea-clue-label',
    };
    const contactClassNameObj = {
        myCustomer: 'my-customer-contact-label',
        myClue: 'my-clue-contact-label',
    };
    labelText = textObj[emailRole] || '';
    labelClass = isContact ? contactClassNameObj[emailRole] || '' : classNameObj[emailRole] || '';
    if (!labelText) {
        return React.createElement(React.Fragment, null);
    }
    if (simpleStyle) {
        return (React.createElement("span", { className: "u-card-theme", style: style },
            "[",
            labelText,
            "]"));
    }
    if (emailRole === 'enterprise' && !showEnterpriseLabel) {
        return React.createElement(React.Fragment, null);
    }
    if (isShort) {
        return (React.createElement(Tooltip, { title: labelText },
            React.createElement("span", { className: `tag-label-short ${labelClass}`, style: style })));
    }
    return React.createElement("span", { className: `tag-label ${labelClass}`, style: style, title: labelText });
};
const CustomerLabel = props => {
    var _a, _b;
    const { simpleStyle, style = {}, contact, curAccount = '', showEnterpriseLabel = false, isShort = false } = props;
    const email = contact ? contactApi.doGetModelDisplayEmail(contact) : '';
    const account = curAccount || ((_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id);
    const name = (_b = contact === null || contact === void 0 ? void 0 : contact.contact) === null || _b === void 0 ? void 0 : _b.contactName;
    if (accountApi.getIsSameSubAccountSync(account === null || account === void 0 ? void 0 : account.toLocaleLowerCase(), email.toLocaleLowerCase())) {
        return React.createElement(React.Fragment, null);
    }
    const emailRole = useContactEmailRole({ email, _account: account, name });
    return React.createElement(CustomerLabelByRole, { role: emailRole, style: style, simpleStyle: simpleStyle, isShort: isShort, showEnterpriseLabel: showEnterpriseLabel });
};
export default CustomerLabel;
